import { WithStyles, withStyles } from '@mui/styles';
import { SortModel } from '@tassat/common-definitions';
import { FirmRecord } from '@tassat/fred-definitions';
import { Location } from 'history';
import { RouteComponentProps } from 'react-router-dom';

import { FirmWithdrawalDetails } from './firmWithdrawalDetails';
import { muiStyles } from './styles';

type RouteParams = {
    accountWithdrawalDataId: string;
};

export interface FirmWithdrawalDetailsProps extends RouteComponentProps<RouteParams>, WithStyles<typeof muiStyles> {
    firm: FirmRecord;
    editWithdrawalInstruction?: (instruction, deleteFunc) => void;
    closeModal?: () => void;
    history: any;
    location: Location<{ tab?: number; sortModel?: SortModel }>;
}

export default withStyles(muiStyles)(FirmWithdrawalDetails);